import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

const Edit = ({ attributes, setAttributes }) => {
  const { margin } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div id="contact" className={`contactUs ${margin}`}>
        <div className="ContactUsCards">
          <InnerBlocks
            template={[['app/contact-card']]}
          />
        </div>
      </div>
    </>
  );
};

export default Edit;
